export function isKeyOf<T extends object>(key: PropertyKey, value: T): key is keyof T {
  return key in value;
}
